module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiHotFilter/assets/white-arrow.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiHotFilter/assets/white-arrow.png
// module id = 1715
// module chunks = 367